import animation from "./svgs/rt-portfolio-icon-animation.svg";
import branding from "./svgs/rt-portfolio-icon-branding.svg";
import featured from "./svgs/rt-portfolio-icon-featured.svg";
import package_design from "./svgs/rt-portfolio-icon-packagedesign.svg";
import photography from "./svgs/rt-portfolio-icon-photography.svg";
import social_media from "./svgs/rt-portfolio-icon-socialmedia.svg";
import web_design from "./svgs/rt-portfolio-icon-webdesign.svg";

/** A portfolio category */
export type Category = {
	active: boolean;
	count: number;
	description: string;
	name: string;
	slug: Service;
	term_id: number;
};

/** The data provided by the PHP */
export type DataSource = {
	categories: string;
	nav: string;
};

/** An item in the portfolio. */
export type Item = {
	post_categories: Array<Category>;
	post_content: string;
	post_excerpt: string;
	post_image: string;
	post_name: string;
	post_title: string;
	post_url: string;
};

/** The randomized background colours for portfolio items. */
export const overlayColours = [
	"#00a79d",
	"#27aae1",
	"#ee2a7b",
	"#be1e2d",
	"#c2b59b",
	"#9b8579",
	"#726658",
	"#ef4136",
	"#f7941d",
	"#8dc63f",
	"#009444",
	"#2bb673",
	"#5f4876",
] as const;

export const serviceImages = {
	animation,
	branding,
	featured,
	"package-design": package_design,
	photography,
	"social-media": social_media,
	"web-design": web_design,
} as const;

export type Service = keyof ServiceImages;
export type ServiceImages = typeof serviceImages;
